    export const EVENT_CREATE_EDIT_OPEN_MODAL = "EVENT_CREATE_EDIT_OPEN_MODAL";
    export const EVENT_CREATE_REQUEST = "EVENT_CREATE_REQUEST";
    export const EVENT_CREATE_RESULT = "EVENT_CREATE_RESULT";
    export const EVENT_EDIT_REQUEST = "EVENT_EDIT_REQUEST";
    export const EVENT_EDIT_RESULT = "EVENT_EDIT_RESULT";
    export const EVENT_GET_REQUEST = "EVENT_GET_REQUEST";
    export const EVENT_GET_RESULT = "EVENT_GET_RESULT";
    export const EVENT_GET_UNIT_TYPES_REQUEST = "EVENT_GET_UNIT_TYPES_REQUEST";
    export const EVENT_GET_UNIT_TYPES_RESULT = "EVENT_GET_UNIT_TYPES_RESULT";